import CustomerTableItemView from '@/applications/sales/components/CustomerTableItemView/CustomerTableItemView'
import EntityDetailsMobile from '@/agilis/mobile/EntityDetailsMobile/EntityDetailsMobile.vue'
export default {
  name: 'CustomerTableItemViewMobile',
  mixins: [CustomerTableItemView],
  components: {
    EntityDetailsMobile
  }
}
